import { cn } from '@dashboard/ui'

import { getPercentFrom } from '@/libs'

export const ProgressCircle = ({
  className = '',
  radius = 16,
  progress = 100,
}: {
  className?: string
  radius?: number
  progress?: number // Value between 0 and 100
}) => {
  const strokeWidth = 4

  const circumference = 2 * Math.PI * radius
  const strokeDashoffset = circumference - (progress / 100) * circumference
  const center = radius + strokeWidth / 2

  return (
    <svg
      className={cn(`absolute size-16`, className)}
      viewBox={`0 0 ${radius * 2 + strokeWidth} ${radius * 2 + strokeWidth}`}
    >
      <circle
        className="stroke-current"
        cx={center}
        cy={center}
        r={radius}
        fill="none"
        stroke="currentColor"
        strokeWidth="4"
        strokeDasharray={circumference}
        strokeDashoffset={strokeDashoffset}
        transform={`rotate(-90 ${center} ${center})`}
      />
    </svg>
  )
}

export const StepProgressCircle = ({
  progress,
}: {
  progress: {
    completed: number
    total: number
  }
}) => {
  return (
    <div className="relative flex size-16 shrink-0">
      {/* Inactive circle */}
      <ProgressCircle className="text-text-quarterary" progress={100} />
      {/* Active circle */}
      <ProgressCircle
        className="text-text-brand-secondary"
        progress={getPercentFrom(progress.completed, progress.total)}
      />
      <div className="absolute left-0 top-0 flex size-full items-center justify-center text-center text-caption-md text-text-tertiary">
        {[progress.completed, progress.total].join('/')}
      </div>
    </div>
  )
}
